/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Glyphicon} from 'react-bootstrap';
import Papa from 'papaparse';

import './NormalizationContainer.scss';

class NormalizationViewCsvUpload extends Component {
  constructor(props) {
    super(props);

    const fileReader = new FileReader();
    fileReader.onloadstart = (event) => this.handleLoadStart(event);
    fileReader.onload = (event) => this.handleLoad(event);

    this.state = {
      fileReader,
      fileName: '',
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {normalizationState} = this.props;
    const {fileReader, fileName} = this.state;

    if (normalizationState.delimiter !== nextProps.normalizationState.delimiter) {
      return true;
    }

    if (normalizationState.csvFileName !== nextProps.normalizationState.csvFileName) {
      return true;
    }

    if (normalizationState.csvData !== nextProps.normalizationState.csvData) {
      return true;
    }

    if (normalizationState.startRow !== nextProps.normalizationState.startRow) {
      return true;
    }

    if (normalizationState.isColumnInFirstRow !== nextProps.normalizationState.isColumnInFirstRow) {
      return true;
    }

    if (normalizationState.selectedColumnIndex !== nextProps.normalizationState.selectedColumnIndex) {
      return true;
    }

    if (fileReader !== nextState.fileReader) {
      return true;
    }

    if (fileName !== nextState.fileName) {
      return true;
    }

    return false;
  }

  handleLoadStart(event) {
    const {showLoading} = this.props;

    console.log('fileReader.onloadstart -> timeStamp:', event.timeStamp);

    showLoading('Loading CSV File...');
  }

  handleLoad(event) {
    const {
      hideLoading,
      fileIsNotSupportedHandler,
      setCsvFileName,
      setCsvRawData,
      setCsvData,
      setCsvTotalRow,
      setSelectedColumnIndex,
      setAllowedToNext,
      normalizationState,
      setIsCsvChanged,
    } = this.props;
    const {fileName} = this.state;

    hideLoading();

    const data = Papa.parse(event.target.result, {
      delimiter: normalizationState.delimiter,
      dynamicTyping: true,
      skipEmptyLines: 'greedy',
    });

    if (data.errors.length) {
      fileIsNotSupportedHandler();

      return;
    }

    console.log('fileReader.onLoad --> timeStamp:', event.timeStamp);

    setCsvRawData(event.target.result);

    // store the state
    setCsvFileName(fileName);
    setCsvData(data.data);
    setCsvTotalRow(data.data.length);
    setSelectedColumnIndex(null);
    setAllowedToNext(false);
    setIsCsvChanged(true);
  }

  handleChangeFile(event) {
    const {fileIsNotSupportedHandler} = this.props;
    const {fileReader} = this.state;

    const fileList = event.target.files;

    if (!fileList || !fileList[0]) {
      return;
    }

    const {name: fileNameLocal} = fileList[0];
    const fileNameLocalArr = fileNameLocal.split('.');

    if (fileNameLocalArr.length > 1 && fileNameLocalArr[fileNameLocalArr.length - 1] !== 'csv') {
      fileIsNotSupportedHandler();

      return;
    }

    this.setState({fileName: fileNameLocal});

    // TODO: check if FileList is empty or not
    // TODO: check if File type is really a csv file

    fileReader.readAsText(fileList[0]);
  }

  handleClickDataHeader(index) {
    const {setSelectedColumnIndex, setAllowedToNext} = this.props;

    console.log('handleClickDataHeader --> index', index);

    setSelectedColumnIndex(index);
    setAllowedToNext(true, index);
  }

  createTableHeader(headerSelectableState) {
    const {normalizationState} = this.props;
    const {csvData, isColumnInFirstRow} = normalizationState;
    const tableHeaders = [];

    // create checkmark header (header with checkmark)
    const checkmarkHeaders = [];

    if (csvData.length === 0) {
      return checkmarkHeaders;
    }

    for (let index = 0; index < csvData[0].length; index += 1) {
      let styleName = 'table-header-normal';

      if (index === normalizationState.selectedColumnIndex) {
        styleName = 'table-header-selected';
      } else if (!headerSelectableState[index]) {
        styleName = 'table-header-error';
      }

      checkmarkHeaders.push(
        <td key={`checkmark-header-${index}`} className={styleName} onClick={() => this.handleClickDataHeader(index)}>
          <Glyphicon glyph="ok" className="selection-glyph" />
        </td>,
      );
    }

    tableHeaders.push(<tr key="checkmark-headers">{checkmarkHeaders}</tr>);

    const colHeaders = [];

    // create column header (header with text)
    for (let index = 0; index < csvData[0].length; index += 1) {
      colHeaders.push(
        <td key={`col-header-${index}`} className="table-header-title">
          {isColumnInFirstRow ? csvData[0][index] : `Reagent ${index + 1}`}
        </td>,
      );
    }

    tableHeaders.push(<tr key="col-headers">{colHeaders}</tr>);

    return tableHeaders;
  }

  createTableData() {
    const {normalizationState} = this.props;
    const {csvData, startRow} = normalizationState;

    const rows = [];

    if (csvData.length === 0) {
      return rows;
    }

    // set initial state that determine wether the header is selectable or not
    const headerSelectableState = [];

    for (let index = 0; index < csvData[0].length; index += 1) {
      headerSelectableState.push(true);
    }

    // generate table content
    for (let row = startRow - 1; row < csvData.length; row += 1) {
      const cols = [];

      for (let col = 0; col < csvData[row].length; col += 1) {
        const colData = csvData[row][col];
        let styleName = 'col_data-valid';

        // eslint-disable-next-line no-restricted-globals
        if ((isNaN(colData) && colData !== 'Zero') || colData === Infinity) {
          styleName = 'col_data-invalid';
          headerSelectableState[col] = false;
        }

        cols.push(
          <td key={`col-${row}${col}`} className={styleName}>
            {colData}
          </td>,
        );
      }

      rows.push(<tr key={`row-${row}`}>{cols}</tr>);
    }

    return {rows, headerSelectableState};
  }

  render() {
    console.log('>>> NormalizationViewCsvUpload rendered <<<');

    const {normalizationState} = this.props;
    const {csvFileName, csvData} = normalizationState;

    const generateData = this.createTableData();
    const tableHeader = this.createTableHeader(generateData.headerSelectableState);
    const tableData = generateData.rows;

    return (
      <div className="csv-upload-container">
        <div className="csv-upload-top-section">
          <div className="csv-upload-button-section">
            <input
              type="file"
              className="file-input"
              accept=".csv"
              onChange={(event) => this.handleChangeFile(event)}
            />
            <Button className="upload-button">
              INPUT FILE
              <Glyphicon glyph="open" className="upload-glyph" />
            </Button>
          </div>
          <div className="csv-upload-info-section">
            {csvFileName || 'Select a .CSV file by tapping on the button beside.'}
          </div>
        </div>
        <span style={{fontWeight: 'bold', margin: '20px 0px 7px 0px', display: 'block', color: '#B9B9B9'}}>
          Tap the data columns that you want to import.
        </span>
        <div className={`csv-upload-table-section${csvData.length === 0 ? ' empty' : ''}`}>
          <table className="table">
            <thead>{tableHeader}</thead>
            <tbody>{tableData}</tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default NormalizationViewCsvUpload;

NormalizationViewCsvUpload.propTypes = {
  normalizationState: PropTypes.any.isRequired,
  showLoading: PropTypes.func.isRequired,
  hideLoading: PropTypes.func.isRequired,
  fileIsNotSupportedHandler: PropTypes.func.isRequired,
  setCsvFileName: PropTypes.func.isRequired,
  setCsvRawData: PropTypes.func.isRequired,
  setCsvData: PropTypes.func.isRequired,
  setCsvTotalRow: PropTypes.func.isRequired,
  setSelectedColumnIndex: PropTypes.func.isRequired,
  setAllowedToNext: PropTypes.func.isRequired,
  setIsCsvChanged: PropTypes.func.isRequired,
};
